export const style = {
  icon: {
    sx: {
      height: 12,
    },
  },
} as const;
